const DEBOUNCED_HANDLER_DELAY = 100;
const DESKTOP_MAX_CONTENT_WIDTH = 1200;
const LOCALE_CODE_REGEX = /^(?:\/\w+)?\/(\w+)\/(\w+)/;
const BAZAAR_VOICE_URL = 'https://api.bazaarvoice.com/data/statistics.json';
const REVIEW_SECTION_ANCHOR = '#pdp-reviews';
const SDL_HEADER_SELECTOR = '.js-header-global .js-header';
const SDL_HEADER_SELECTOR_APC = '.js-header-global .js-header-apc';
const SDL_REDESIGN_HEADER_SELECTOR = '.se2--header-se .se2--header-se--common-part';
const siteType = {
    B2B: 'b2b',
    B2C: 'b2c',
};
const b2cSiteTypeURLPrefix = 'home';
const rangeBasePath = 'product-range';
const COMMERCIAL_STATUS_MAX_LENGTH = 28;
const TAB_BAR_HEIGHT = 48;
const scrollBehavior = {
    SMOOTH: 'smooth',
    AUTO: 'auto',
};
const SLASH = '/';
var ECommercialStatus;
(function (ECommercialStatus) {
    ECommercialStatus["COMMERCIALIZED"] = "COMMERCIALIZED";
    ECommercialStatus["LEGACY"] = "LEGACY";
    ECommercialStatus["PRECOMMERCIALIZED"] = "PRECOMMERCIALIZED";
    ECommercialStatus["END_OF_COMMERCIALIZATION_ANNOUNCED"] = "END_OF_COMMERCIALIZATION_ANNOUNCED";
})(ECommercialStatus || (ECommercialStatus = {}));
var EPromiseStatus;
(function (EPromiseStatus) {
    EPromiseStatus["PENDING"] = "pending";
    EPromiseStatus["FULFILLED"] = "fulfilled";
    EPromiseStatus["REJECTED"] = "rejected";
    EPromiseStatus["SETTLED"] = "settled";
})(EPromiseStatus || (EPromiseStatus = {}));
const sustainabilityGroupNameAtg = {
    groupExternalLabels: 'group_external_labels_atg',
    sustainabilityGroupDefault: 'sustainability_group_default_atg',
    groupResourcePerformance: 'group_resource_performance_atg',
    groupChemicalPerformance: 'group_chemical_performance_atg',
};
const sustainabilityGroupNameSpryker = {
    groupExternalLabels: 'group_external_labels',
    sustainabilityGroupDefault: 'sustainability_group_default',
    groupResourcePerformance: 'group_resource_performance',
    groupChemicalPerformance: 'group_chemical_performance',
};
var Protocol;
(function (Protocol) {
    Protocol["HTTP"] = "http";
    Protocol["HTTPS"] = "https";
})(Protocol || (Protocol = {}));
var NUMERIC_SEPARATOR;
(function (NUMERIC_SEPARATOR) {
    NUMERIC_SEPARATOR["COMMA"] = ",";
    NUMERIC_SEPARATOR["DOT"] = ".";
})(NUMERIC_SEPARATOR || (NUMERIC_SEPARATOR = {}));
var FeatureStatus;
(function (FeatureStatus) {
    FeatureStatus["ENABLED"] = "enabled";
    FeatureStatus["DISABLED"] = "disabled";
})(FeatureStatus || (FeatureStatus = {}));
const PES_USER = {
    TOKEN_KEY: 'pes_user_token_key',
};
var ExtraBadgesCharId;
(function (ExtraBadgesCharId) {
    ExtraBadgesCharId["ATS_MADE_IN_AMERICA"] = "ATS_MADE_IN_AMERICA";
})(ExtraBadgesCharId || (ExtraBadgesCharId = {}));
var CircularProductTypes;
(function (CircularProductTypes) {
    CircularProductTypes["LINEAR"] = "linear";
    CircularProductTypes["REFURBISHED"] = "refurbished";
    CircularProductTypes["REPACKED"] = "repacked";
    CircularProductTypes["REMANUFACTURED"] = "remanufactured";
})(CircularProductTypes || (CircularProductTypes = {}));
var HMCPlatform;
(function (HMCPlatform) {
    HMCPlatform["SE"] = "SE";
    HMCPlatform["MySchneider"] = "MySchneider";
})(HMCPlatform || (HMCPlatform = {}));
const CAASContentOverviewSlotName = 'caas-content-overview';
// Product Selector
const SC = 'sc';
const CR = 'cr';

var EStatus;
(function (EStatus) {
    EStatus["INFORMATIONAL"] = "INFORMATIONAL";
    EStatus["WARNING"] = "WARNING";
    EStatus["ERROR"] = "ERROR";
})(EStatus || (EStatus = {}));
var ENotificationType;
(function (ENotificationType) {
    ENotificationType["PRODUCTS_LIST"] = "PRODUCTS_LIST";
    ENotificationType["SIMPLE_WITH_RELOAD"] = "SIMPLE_WITH_RELOAD";
    ENotificationType["WITH_HTML"] = "WITH_HTML";
})(ENotificationType || (ENotificationType = {}));
var ENotificationPageType;
(function (ENotificationPageType) {
    ENotificationPageType["COMPARATOR"] = "COMPARATOR";
    ENotificationPageType["PRODUCT_CART"] = "CART";
})(ENotificationPageType || (ENotificationPageType = {}));
var ENotificationEvent;
(function (ENotificationEvent) {
    ENotificationEvent["ACTION_DID_CLICK_EVENT"] = "actionDidClick";
})(ENotificationEvent || (ENotificationEvent = {}));

const DOCUMENTS = 'documents';
var EPriceSpiderName;
(function (EPriceSpiderName) {
    EPriceSpiderName["DEFAULT"] = "B2C price spider widget";
    EPriceSpiderName["PRIVATE"] = "B2B price spider widget";
})(EPriceSpiderName || (EPriceSpiderName = {}));
var ECustomerType;
(function (ECustomerType) {
    ECustomerType["CLASSIFICATION1"] = "ATG_CLASSVALUE1";
})(ECustomerType || (ECustomerType = {}));
var EPriceSpiderKey;
(function (EPriceSpiderKey) {
    // PUBLIC and LEGACY keys moved from APC codebase
    EPriceSpiderKey["PUBLIC"] = "5bbf65a04a17ef05e8d8a0ae";
    EPriceSpiderKey["LEGACY"] = "5900be5a8196951772ce423f";
    // PRIVATE key copied from PriceSpider documentation
    EPriceSpiderKey["PRIVATE"] = "65304d2283d990000e23ce8c";
})(EPriceSpiderKey || (EPriceSpiderKey = {}));
var ESustainabilityType;
(function (ESustainabilityType) {
    ESustainabilityType["GREEN_PREMIUM"] = "GREEN_PREMIUM";
    ESustainabilityType["DEFAULT"] = "DEFAULT";
})(ESustainabilityType || (ESustainabilityType = {}));
var ESustainabilityGroupType;
(function (ESustainabilityGroupType) {
    ESustainabilityGroupType["DEFAULT"] = "DEFAULT";
    ESustainabilityGroupType["PRIMARY"] = "PRIMARY";
})(ESustainabilityGroupType || (ESustainabilityGroupType = {}));
var ECarouselRelation;
(function (ECarouselRelation) {
    ECarouselRelation["crossSellLife"] = "crossSellLife";
    ECarouselRelation["crosssell"] = "crosssell";
    ECarouselRelation["upsell"] = "upsell";
    ECarouselRelation["Compatiblesoftware"] = "Compatiblesoftware";
    ECarouselRelation["compatibleSoftware"] = "compatibleSoftware";
})(ECarouselRelation || (ECarouselRelation = {}));

var EEvent;
(function (EEvent) {
    EEvent["COMPARE_CONTROL_CLICK"] = "comparatorClick";
    EEvent["COMPARATOR_PRODUCTS_CHANGE"] = "comparatorProductsChange";
})(EEvent || (EEvent = {}));

const myProductsGroupType = {
    SINGLE: 'single',
    GROUP: 'group',
};
// Status of update:
// 'SUCCESS';
// 'ERROR' - when not all products are found and request `allowPartialAdding=false`;
// 'PRODUCTS_UNAVAILABLE' - not found any product in catalog;.
const myProductsResponseStatus = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};
Object.assign(Object.assign({}, myProductsResponseStatus), { PRODUCTS_UNAVAILABLE: 'PRODUCTS_UNAVAILABLE' });
Object.assign({}, myProductsResponseStatus);

var ETabType;
(function (ETabType) {
    ETabType["DOCUMENTS"] = "DOCUMENTS";
    ETabType["COMPATIBLE_PRODUCTS"] = "COMPATIBLE_PRODUCTS";
    ETabType["SPECIFICATIONS"] = "SPECIFICATIONS";
    ETabType["EPDS"] = "EPDS";
    ETabType["DDC_DOCUMENTS"] = "DDC_DOCUMENTS";
    ETabType["DDC_SOFTWARE"] = "DDC_SOFTWARE";
    ETabType["SOFTWARE_CAROUSEL"] = "SOFTWARE_CAROUSEL";
    ETabType["LIFECYCLE_CAROUSEL"] = "LIFECYCLE_CAROUSEL";
    ETabType["EXPLORE_CAROUSEL"] = "EXPLORE_CAROUSEL";
    ETabType["FREQUENTLY_BOUGHT_CAROUSEL"] = "FREQUENTLY_BOUGHT_CAROUSEL";
    ETabType["FAQ"] = "FAQ";
    ETabType["REVIEWS"] = "REVIEWS";
    ETabType["ECOSTRUXURE"] = "ECOSTRUXURE";
    ETabType["SUSTAINABILITY"] = "SUSTAINABILITY";
    ETabType["ENVIRONMENTALDATA"] = "ENVIRONMENTALDATA";
})(ETabType || (ETabType = {}));
const TABS_ORDER = [
    ETabType.DOCUMENTS,
    ETabType.COMPATIBLE_PRODUCTS,
    ETabType.SOFTWARE_CAROUSEL,
    ETabType.LIFECYCLE_CAROUSEL,
    ETabType.SPECIFICATIONS,
    ETabType.SUSTAINABILITY,
    ETabType.ENVIRONMENTALDATA,
    ETabType.EPDS,
    ETabType.DDC_DOCUMENTS,
    ETabType.DDC_SOFTWARE,
    ETabType.EXPLORE_CAROUSEL,
    ETabType.FREQUENTLY_BOUGHT_CAROUSEL,
    ETabType.FAQ,
    ETabType.REVIEWS,
];

var ClientApps;
(function (ClientApps) {
    ClientApps["PPW"] = "PPW";
    ClientApps["PBS"] = "PBS";
})(ClientApps || (ClientApps = {}));
const MAX_BREADCRUMBS_RECORDS_COUNT = 50;
var BreadcrumbTypes;
(function (BreadcrumbTypes) {
    BreadcrumbTypes["PPW"] = "PUBLIC_WEB_BREADCRUMBS_TYPE";
    BreadcrumbTypes["PBS"] = "PBS_BREADCRUMBS_TYPE";
})(BreadcrumbTypes || (BreadcrumbTypes = {}));
var PageNames;
(function (PageNames) {
    PageNames["ALLPRODUCTS"] = "ALLPRODUCTS";
    PageNames["SITE"] = "SITE";
    PageNames["BUSINESS"] = "BUSINESS";
    PageNames["CATEGORY"] = "CATEGORY";
    PageNames["SUBCATEGORY"] = "SUBCATEGORY";
    PageNames["RANGE"] = "RANGE";
    PageNames["PRODUCT"] = "PRODUCT";
})(PageNames || (PageNames = {}));
const { SITE, BUSINESS, CATEGORY, SUBCATEGORY, RANGE, PRODUCT, ALLPRODUCTS, } = PageNames;
const breadcrumbsLevels = {
    [BreadcrumbTypes.PPW]: [
        SITE,
        ALLPRODUCTS,
        BUSINESS,
        CATEGORY,
        SUBCATEGORY,
        RANGE,
        PRODUCT,
    ],
    [BreadcrumbTypes.PBS]: [
        ALLPRODUCTS,
        CATEGORY,
        SUBCATEGORY,
        RANGE,
        PRODUCT,
    ],
};

var PesLinkEnum;
(function (PesLinkEnum) {
    PesLinkEnum["button"] = "button";
    PesLinkEnum["link"] = "link";
})(PesLinkEnum || (PesLinkEnum = {}));

var CountrySelectorConstants;
(function (CountrySelectorConstants) {
    CountrySelectorConstants["CS_ENDPOINT"] = "/{cc}/{lc}/download/download-api/getCountryLabels/";
    CountrySelectorConstants["COUNTRY_CODE"] = "ww";
    CountrySelectorConstants["LANGUAGE_CODE"] = "en";
    CountrySelectorConstants["APP_SOURCE"] = "SE";
    CountrySelectorConstants["NOT_SCOPED_MESSAGE"] = "The specified document is not available anywhere..";
    CountrySelectorConstants["TOGGLE_CLICK"] = "false";
})(CountrySelectorConstants || (CountrySelectorConstants = {}));

/**
 * Buttons
 */
var EAvailabilityType;
(function (EAvailabilityType) {
    EAvailabilityType["ADD_TO_CART"] = "ADD_TO_CART";
    EAvailabilityType["PURCHASE_CD"] = "PURCHASE_CD";
    EAvailabilityType["DISCONTINUED"] = "DISCONTINUED";
})(EAvailabilityType || (EAvailabilityType = {}));
var EApcButtonType;
(function (EApcButtonType) {
    EApcButtonType["ADD_TO_CART"] = "ADD_TO_CART";
    EApcButtonType["DOWNLOAD_BUTTON"] = "DOWNLOAD_BUTTON";
})(EApcButtonType || (EApcButtonType = {}));
const ADD_TO_CART_EXCEPTION_CODES = {
    MAXIMUM_COUNT_WITH_LINK: 'maximumCartCountWithLinkError',
    MAXIMUM_COUNT: 'maximumCartCountError',
};
const PLACEHOLDERS = {
    HOST: '#apcHost#',
    COUNTRY: '#countryCode#',
    LANGUAGE: '#languageCode#',
    FAVORITES_LINK: '{favorites-link}',
    PRODUCT_ID: '#productId#',
    SKUS: '#skus#',
    QTY: '#qty#',
    Chat_CSC_ID: '#Chat_CSC_ID#',
};
const QUERY_LOCALES = `languageCode=${PLACEHOLDERS.LANGUAGE}&countryCode=${PLACEHOLDERS.COUNTRY}&Chat_CSC_ID=${PLACEHOLDERS.Chat_CSC_ID}`;
const QUERY_LOCALES_WITHOUT_CHAT = `languageCode=${PLACEHOLDERS.LANGUAGE}&countryCode=${PLACEHOLDERS.COUNTRY}`;
const SKU_LIST = `&SKU_List=${PLACEHOLDERS.SKUS}`;
const QTY_LIST = `&qty_list=${PLACEHOLDERS.QTY}&Chat_CSC_ID=${PLACEHOLDERS.Chat_CSC_ID}`;
const URLS = {
    ADD_TO_CART: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrder?${QUERY_LOCALES}`,
    GO_TO_CART: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/cart/shoppingCart.jsp`,
    PRODUCT_AVAILABILITY: `${PLACEHOLDERS.HOST}/rest/model/schneider/catalog/availability/rest/ProductAvailabilityActor/pdpProductAvailabilityInfo?partNumbersList=${PLACEHOLDERS.PRODUCT_ID}&${QUERY_LOCALES}`,
    ADD_TO_FAVORITES: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToFavorites?${QUERY_LOCALES}`,
    REMOVE_FROM_FAVORITES: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/removeItemFromFavorites?${QUERY_LOCALES}`,
    MY_LIST: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/myaccount/myAccountMyList.jsp`,
    CREATE_ACCOUNT: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/pdp/authBeforeAddingToMyFavorites.jsp?skuId=SKU-${PLACEHOLDERS.PRODUCT_ID}&productId=P-${PLACEHOLDERS.PRODUCT_ID}&type=reg`,
    SIGN_IN: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/pdp/authBeforeAddingToMyFavorites.jsp?skuId=SKU-${PLACEHOLDERS.PRODUCT_ID}&productId=P-${PLACEHOLDERS.PRODUCT_ID}`,
    ADD_TO_CART_SUCCESS: `/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrderSuccess?${QUERY_LOCALES}`,
    ADD_TO_CART_ERROR: `/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrderError?${QUERY_LOCALES}`,
    COMPARISON_ADD_TO_CART: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemsToOrder?${QUERY_LOCALES_WITHOUT_CHAT}${SKU_LIST}${QTY_LIST}`,
};
var ECtaButtonTypes;
(function (ECtaButtonTypes) {
    ECtaButtonTypes["BUY_ONLINE_BUTTON_REGULAR"] = "BUY_ONLINE_BUTTON_REGULAR";
    ECtaButtonTypes["BUY_ONLINE_BUTTON_APC"] = "BUY_ONLINE_BUTTON_APC";
    ECtaButtonTypes["DOWNLOAD_BUTTON"] = "DOWNLOAD_BUTTON";
    ECtaButtonTypes["NOTIFY_ME_BUTTON"] = "NOTIFY_ME_BUTTON";
    ECtaButtonTypes["ADD_TO_CART_BUTTON"] = "ADD_TO_CART_BUTTON";
    ECtaButtonTypes["PROMOTED_BUTTON"] = "PROMOTED_BUTTON";
    ECtaButtonTypes["PRODUCT_SELECTOR_BUTTON"] = "PRODUCT_SELECTOR_BUTTON";
})(ECtaButtonTypes || (ECtaButtonTypes = {}));
const PRIMARY_BUTTONS = [
    // order matters
    ECtaButtonTypes.NOTIFY_ME_BUTTON,
    ECtaButtonTypes.DOWNLOAD_BUTTON,
    ECtaButtonTypes.PRODUCT_SELECTOR_BUTTON,
    ECtaButtonTypes.BUY_ONLINE_BUTTON_REGULAR,
    ECtaButtonTypes.BUY_ONLINE_BUTTON_APC,
];
const SECONDARY_BUTTONS = [ECtaButtonTypes.ADD_TO_CART_BUTTON];
const APC_PRIMARY_BUTTONS = [
    // order matters
    ECtaButtonTypes.NOTIFY_ME_BUTTON,
    ECtaButtonTypes.DOWNLOAD_BUTTON,
    ECtaButtonTypes.PRODUCT_SELECTOR_BUTTON,
    ECtaButtonTypes.BUY_ONLINE_BUTTON_REGULAR,
];
const DEFAULT_CTA_DROPDOWN_LABEL = 'More Options';
// Product CTA's
const productCtasColors = {
    PRIMARY_BLUE: 'primaryBlue',
    SECONDARY_BLUE: 'secondaryBlue',
    PRIMARY_GREEN: 'primaryGreen',
    SECONDARY_GREEN: 'secondaryGreen',
};
const MAX_CTA_LIMIT = 3;
const ADDITIONAL_CTA_LINKS = 'addition-links';
const NUMBER_OF_BUTTONS_BEFORE = 3;
const productCtasButtonType = {
    CART: 'cart',
    FAVORITES: 'favorites',
    COMPARE: 'compare',
};
const productCtas = {
    buttons: {
        [productCtasButtonType.CART]: {
            isShown: true,
            list: [],
            color: productCtasColors.PRIMARY_BLUE,
            icons: {
                addIcon: 'shopping-cart',
                disableIconInPdpCtaBlock: true,
            },
            dataset: {
                daElementId: 'add_p',
            },
            labels: {},
        },
        [productCtasButtonType.FAVORITES]: {
            isShown: false,
            list: [],
            color: productCtasColors.SECONDARY_BLUE,
            icons: {
                addIcon: 'star',
                removeIcon: 'star-filled',
            },
            dataset: {
                daElementId: 'add_p',
            },
            labels: {},
        },
    },
    productProp: 'repositoryId',
};
// Icons
const pesIconMirrorDirection = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
    BOTH: 'both',
};
const LOAD_TIMEOUT = 10000;
const ICON_FONT_NAME = 'se-icon';
const MAX_LINE_LIMIT = {
    desktop: 5,
    mobile: 4,
};
const MAX_IMG_LIMIT = 3;
const DEFAULT_LINE_HEIGHT = '24px';
const pesIconSizes = {
    NANO: 'nano',
    MICRO: 'micro',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    XLARGE: 'xlarge',
};
const ONLINE_SOFTWARE = 'Online Software';
const PDP_SOFTWARE = 'Software';
const ONLINE_CONFIGURATOR = 'Online Configurator';
const CONFIGURATOR = 'Configurator';
const CTA_TYPES = {
    ONLINE_SOFTWARE,
    PDP_SOFTWARE,
    ONLINE_CONFIGURATOR,
    CONFIGURATOR,
    BUY_ONLINE: 'buy-online',
    REQUEST_DEMO: 'request-demo',
    SOFTWARE_FREE_TRIAL: 'software-free-trial',
    ASK_THE_COMMUNITY: 'ask-the-community',
    TALK_TO_AN_EXPERT: 'talk-to-an-expert',
};
const ONLINE_CTA_TYPES = {
    [ONLINE_SOFTWARE]: true,
    [ONLINE_CONFIGURATOR]: true,
    [CTA_TYPES.BUY_ONLINE]: true,
    [CTA_TYPES.REQUEST_DEMO]: true,
    [CTA_TYPES.SOFTWARE_FREE_TRIAL]: true,
    [CTA_TYPES.ASK_THE_COMMUNITY]: true,
    [CTA_TYPES.TALK_TO_AN_EXPERT]: true,
};
var RangeCTAPosition;
(function (RangeCTAPosition) {
    RangeCTAPosition["EMPHASIZED"] = "Primary-button";
    RangeCTAPosition["STANDARD"] = "Secondary-button";
    RangeCTAPosition["SUBDUED"] = "Subdued-button";
    RangeCTAPosition["OPTIONS"] = "Options";
})(RangeCTAPosition || (RangeCTAPosition = {}));

const DEFAULT_CONFIGURATIONS = {
    APIConfigList: [],
    maxRetries: 0,
    setUpAPITimeout: 4000,
    defaultContentType: 'application/json',
};
var REQUEST_SERVICE_EVENTS;
(function (REQUEST_SERVICE_EVENTS) {
    REQUEST_SERVICE_EVENTS["CONGIFURED"] = "configured";
})(REQUEST_SERVICE_EVENTS || (REQUEST_SERVICE_EVENTS = {}));
const DEFAULT_API_VERSION_FORMAT = '; version=';
var REQUEST_ERROR_TYPES;
(function (REQUEST_ERROR_TYPES) {
    REQUEST_ERROR_TYPES["API_SETUP_TIMEOUT"] = "api-setup-timeout";
    REQUEST_ERROR_TYPES[REQUEST_ERROR_TYPES["RESOURCE_NOT_FOUND"] = 404] = "RESOURCE_NOT_FOUND";
    REQUEST_ERROR_TYPES[REQUEST_ERROR_TYPES["SERVER_FAILURE"] = 502] = "SERVER_FAILURE";
    REQUEST_ERROR_TYPES["DEFAULT"] = "default";
})(REQUEST_ERROR_TYPES || (REQUEST_ERROR_TYPES = {}));
const REQUEST_ERRORS = {
    [REQUEST_ERROR_TYPES.API_SETUP_TIMEOUT]: {
        message: 'API timed out while trying to setup',
        statusCode: -1,
    },
    [REQUEST_ERROR_TYPES.RESOURCE_NOT_FOUND]: {
        message: 'Resource was not found',
        statusCode: 404,
    },
    [REQUEST_ERROR_TYPES.SERVER_FAILURE]: {
        message: 'Server failed while processing request and could not respond as expected',
        statusCode: 502,
    },
    [REQUEST_ERROR_TYPES.DEFAULT]: {
        message: 'Unknown error',
        statusCode: -2,
    },
};

var ESectionHeaderColors;
(function (ESectionHeaderColors) {
    ESectionHeaderColors["DEFAULT"] = "default";
    ESectionHeaderColors["INHERIT"] = "inherit";
    ESectionHeaderColors["FUCHSIA"] = "secondary-fuchsia";
})(ESectionHeaderColors || (ESectionHeaderColors = {}));

var RESPONSE_TYPES;
(function (RESPONSE_TYPES) {
    RESPONSE_TYPES["JSON"] = "json";
    RESPONSE_TYPES["BLOB"] = "blob";
    RESPONSE_TYPES["ARRAY_BUFFER"] = "arrayBuffer";
    RESPONSE_TYPES["FORM_DATA"] = "formData";
    RESPONSE_TYPES["TEXT"] = "text";
})(RESPONSE_TYPES || (RESPONSE_TYPES = {}));

// TODO: Migrate to QdsSize and QdsImportance
// https://jira.se.com/browse/PEXS-15578
var EQdsButtonSize;
(function (EQdsButtonSize) {
    EQdsButtonSize["SMALL"] = "small";
    EQdsButtonSize["LARGE"] = "large";
    EQdsButtonSize["STANDARD"] = "standard";
})(EQdsButtonSize || (EQdsButtonSize = {}));
var EQdsButtonImportance;
(function (EQdsButtonImportance) {
    EQdsButtonImportance["EMPHASIZED"] = "emphasized";
    EQdsButtonImportance["STANDARD"] = "standard";
    EQdsButtonImportance["SUBDUED"] = "subdued";
})(EQdsButtonImportance || (EQdsButtonImportance = {}));
var QdsChipType;
(function (QdsChipType) {
    QdsChipType["CLOSABLE"] = "closable";
    QdsChipType["SELECTABLE"] = "selectable";
})(QdsChipType || (QdsChipType = {}));
var QdsSize;
(function (QdsSize) {
    QdsSize["SMALL"] = "small";
    QdsSize["LARGE"] = "large";
    QdsSize["STANDARD"] = "standard";
})(QdsSize || (QdsSize = {}));
var QdsImportance;
(function (QdsImportance) {
    QdsImportance["EMPHASIZED"] = "emphasized";
    QdsImportance["STANDARD"] = "standard";
    QdsImportance["SUBDUED"] = "subdued";
})(QdsImportance || (QdsImportance = {}));
var QdsSelectType;
(function (QdsSelectType) {
    QdsSelectType["SELECT_MULTIPLE"] = "select-multiple";
    QdsSelectType["SELECT_ONE"] = "select-one";
})(QdsSelectType || (QdsSelectType = {}));
var EQdsIcons;
(function (EQdsIcons) {
    EQdsIcons["ARROW_DOWN"] = "arrow-down";
    EQdsIcons["ARROW_DOWN_TRAY"] = "arrow-down-tray";
    EQdsIcons["ARROW_TOP_RIGHT_ON_SQUARE"] = "arrow-top-right-on-square";
    EQdsIcons["ARROW_UP"] = "arrow_up";
    EQdsIcons["ARROW_UP_DOWN_CIRCLE"] = "arrow-up-down-circle";
    EQdsIcons["ARROWS_FACING_RIGHT_LEFT"] = "arrows-facing-right-left";
    EQdsIcons["BELL"] = "bell";
    EQdsIcons["BELL_WAVES"] = "bell-waves";
    EQdsIcons["BOX_ARROW_CLOCKWISE"] = "box-arrow-clockwise";
    EQdsIcons["CHAT_BUBBLES_SQUARE_ELLIPSIS"] = "chat-bubbles-square-ellipsis";
    EQdsIcons["CHECK_WRITING_BOARD"] = "check-writing-board";
    EQdsIcons["CHECK_CIRCLE"] = "check-circle";
    EQdsIcons["CHEVRON_LEFT"] = "chevron-left";
    EQdsIcons["DOTS_3_MENU_HORIZONTAL"] = "dots-3-horizontal";
    EQdsIcons["FINGER_POINTING_UP"] = "finger-pointing-up";
    EQdsIcons["LAPTOP_SIDE"] = "laptop-side";
    EQdsIcons["PAGE_LINES"] = "page-lines";
    EQdsIcons["PAGE_PDF"] = "page-pdf";
    EQdsIcons["PAGE_XLS"] = "page-xlsx";
    EQdsIcons["PAGE_XML"] = "page-xml";
    EQdsIcons["PAGES_DOUBLE"] = "pages-double";
    EQdsIcons["PENCIL"] = "pencil";
    EQdsIcons["PERSON_WRITING_PAD"] = "person-writing-pad";
    EQdsIcons["PERSONS_SMALL_BIG"] = "persons-small-big";
    EQdsIcons["RECTANGLE_LOCATION_PIN"] = "rectangle-location-pin";
    EQdsIcons["SCREEN_GRAPH"] = "screen-graph";
    EQdsIcons["SHOPPING_CART"] = "shopping-cart";
    EQdsIcons["SHOPPING_CART_ARROW"] = "shopping-cart-arrow";
    EQdsIcons["SQUARE_BEHIND_ANOTHER"] = "square-behind-another";
    EQdsIcons["SQUARES_SELECTED"] = "squares-selected";
    EQdsIcons["STAR"] = "star";
    EQdsIcons["STAR_FILLED"] = "star-filled";
    EQdsIcons["TRASH_CAN"] = "trash-can";
})(EQdsIcons || (EQdsIcons = {}));
const LINK_TYPES = {
    CONTACT_SALES: 'CONTACT_SALES',
    CONTACT_SUPPORT: 'CONTACT_SUPPORT',
    COMPARE: 'COMPARE',
    REGISTER_TO_NEWSLETTER: 'REGISTER_TO_NEWSLETTER',
    REGISTER_PRODUCT: 'REGISTER_PRODUCT',
    ADD_TO_MY_PRODUCTS: 'ADD_TO_MY_PRODUCTS',
    CHECK_DISTRIBUTOR: 'CHECK_DISTRIBUTOR',
};
const ACTION_BLOCK_TYPES = {
    PRODUCTS_FROM_A_TO_Z: 'PRODUCTS_FROM_A_TO_Z',
    PRODUCT_SELECTOR_LIST: 'PRODUCT_SELECTOR_LIST',
    MASTER_RANGE_PRODUCT: 'MASTER_RANGE_PRODUCT',
    DOWNLOAD_CENTER: 'DOWNLOAD_CENTER',
};
const ICONS_BY_TYPE = {
    [LINK_TYPES.CONTACT_SALES]: EQdsIcons.CHECK_WRITING_BOARD,
    [LINK_TYPES.CONTACT_SUPPORT]: EQdsIcons.CHAT_BUBBLES_SQUARE_ELLIPSIS,
    [LINK_TYPES.REGISTER_TO_NEWSLETTER]: EQdsIcons.BELL_WAVES,
    [LINK_TYPES.REGISTER_PRODUCT]: EQdsIcons.PAGE_LINES,
    [LINK_TYPES.CHECK_DISTRIBUTOR]: EQdsIcons.CHECK_WRITING_BOARD,
    // All-products
    [ACTION_BLOCK_TYPES.PRODUCTS_FROM_A_TO_Z]: 'action_filter',
    [ACTION_BLOCK_TYPES.PRODUCT_SELECTOR_LIST]: 'product_selector',
    [ACTION_BLOCK_TYPES.MASTER_RANGE_PRODUCT]: 'box1',
    [ACTION_BLOCK_TYPES.DOWNLOAD_CENTER]: 'action_doc_new',
};
const TARGET_BY_TYPE = {
    [LINK_TYPES.CONTACT_SALES]: '_self',
    [LINK_TYPES.CONTACT_SUPPORT]: '_blank',
    [LINK_TYPES.REGISTER_PRODUCT]: '_blank',
    [LINK_TYPES.CHECK_DISTRIBUTOR]: '_self',
};

var STATUS_TYPES;
(function (STATUS_TYPES) {
    STATUS_TYPES["IDLE"] = "idle";
    STATUS_TYPES["LOADING"] = "loading";
    STATUS_TYPES["SUCCEEDED"] = "succeeded";
    STATUS_TYPES["FAILED"] = "failed";
})(STATUS_TYPES || (STATUS_TYPES = {}));

// Maps locale unsupported by some browsers to fallbacks array
const LOCALE_FALLBACKS = {
    // 'no' macrolanguage isn't supported by modern browsers (Chrome, Firefox, Edge)
    'no-NO': ['no-NO', 'nb', 'nn', 'da'],
};
const fractionDigits = {
    MIN: 2,
    MAX: 2,
};
var ECurrency;
(function (ECurrency) {
    ECurrency["EUR"] = "EUR";
})(ECurrency || (ECurrency = {}));

export { ADDITIONAL_CTA_LINKS as $, ALLPRODUCTS as A, BAZAAR_VOICE_URL as B, COMMERCIAL_STATUS_MAX_LENGTH as C, DEFAULT_CONFIGURATIONS as D, EAvailabilityType as E, ECustomerType as F, fractionDigits as G, productCtasButtonType as H, b2cSiteTypeURLPrefix as I, LOCALE_CODE_REGEX as J, ECarouselRelation as K, LOCALE_FALLBACKS as L, MAX_BREADCRUMBS_RECORDS_COUNT as M, NUMERIC_SEPARATOR as N, ONLINE_CTA_TYPES as O, PageNames as P, QdsSize as Q, REVIEW_SECTION_ANCHOR as R, SDL_REDESIGN_HEADER_SELECTOR as S, TAB_BAR_HEIGHT as T, ETabType as U, PRODUCT as V, RANGE as W, SUBCATEGORY as X, CATEGORY as Y, SITE as Z, RangeCTAPosition as _, EApcButtonType as a, NUMBER_OF_BUTTONS_BEFORE as a0, MAX_CTA_LIMIT as a1, ECommercialStatus as a2, DEFAULT_CTA_DROPDOWN_LABEL as a3, CAASContentOverviewSlotName as a4, rangeBasePath as a5, SC as a6, PES_USER as a7, DEBOUNCED_HANDLER_DELAY as a8, MAX_IMG_LIMIT as a9, EStatus as aA, ENotificationType as aB, ENotificationPageType as aC, DESKTOP_MAX_CONTENT_WIDTH as aD, CountrySelectorConstants as aE, ACTION_BLOCK_TYPES as aF, pesIconSizes as aa, PRIMARY_BUTTONS as ab, SECONDARY_BUTTONS as ac, APC_PRIMARY_BUTTONS as ad, PesLinkEnum as ae, LINK_TYPES as af, ICONS_BY_TYPE as ag, TARGET_BY_TYPE as ah, CR as ai, ExtraBadgesCharId as aj, pesIconMirrorDirection as ak, TABS_ORDER as al, MAX_LINE_LIMIT as am, ESectionHeaderColors as an, ESustainabilityGroupType as ao, ESustainabilityType as ap, sustainabilityGroupNameSpryker as aq, sustainabilityGroupNameAtg as ar, myProductsGroupType as as, PLACEHOLDERS as at, URLS as au, ADD_TO_CART_EXCEPTION_CODES as av, DOCUMENTS as aw, DEFAULT_LINE_HEIGHT as ax, ICON_FONT_NAME as ay, LOAD_TIMEOUT as az, productCtas as b, EQdsButtonImportance as c, EQdsButtonSize as d, SDL_HEADER_SELECTOR_APC as e, SDL_HEADER_SELECTOR as f, SLASH as g, Protocol as h, scrollBehavior as i, EEvent as j, ClientApps as k, breadcrumbsLevels as l, myProductsResponseStatus as m, BreadcrumbTypes as n, BUSINESS as o, productCtasColors as p, CircularProductTypes as q, STATUS_TYPES as r, siteType as s, REQUEST_ERRORS as t, REQUEST_ERROR_TYPES as u, DEFAULT_API_VERSION_FORMAT as v, REQUEST_SERVICE_EVENTS as w, RESPONSE_TYPES as x, ONLINE_SOFTWARE as y, PDP_SOFTWARE as z };
